import Spinner from '../../helpers/Spinner';

const MyComplexityInfo = ({ onMouseEnter, onMouseLeave }) => {
	return (
		<div className="complexity-info-container"
                >

			{/* First, add the arrow div here */}
			<div className="contribtionDocStatusArrow_complexity"></div>

			{/* Then, add the content div below */}
			<div className="complexityMessage"><span  className="complexity-message-text">You cannot change the Complexity</span></div>
		</div>
	);
};

export default MyComplexityInfo;
